export default "__VITE_ASSET__BekP2TLY__"